document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.ps-buy');
  if (!section) return;

  var eyebrow = section.querySelector('.ps-buy__copy > .ps-eyebrow');
  if (eyebrow) eyebrow.textContent = 'THE 2 PACK';

  var copy = section.querySelector('.ps-buy__copy > p:not(.ps-eyebrow)');
  if (copy) copy.textContent = 'One for the court. One clean in the bag. A dry grip ready when the next game starts.';

  var details = section.querySelector('.ps-buy__copy > dl');
  if (!details) return;

  section.querySelectorAll('.ps-buy__price').forEach(function (el) { el.remove(); });

  var rows = details.querySelectorAll('div');
  rows.forEach(function (row) {
    var dt = row.querySelector('dt');
    var dd = row.querySelector('dd');
    if (!dt || !dd) return;
    var label = dt.textContent.trim().toLowerCase();
    if (label === 'pack size') dd.textContent = '2 Paddle Socks';
    if (label === 'launch color') dd.innerHTML = 'Grip Green <span aria-hidden="true">•</span>';
  });

  var hasPrice = Array.prototype.some.call(details.querySelectorAll('dt'), function (dt) {
    return dt.textContent.trim().toLowerCase() === 'price';
  });
  if (!hasPrice) {
    var priceRow = document.createElement('div');
    priceRow.className = 'ps-buy__line ps-buy__line--price';
    priceRow.innerHTML = '<dt>Price</dt><dd>$24.99</dd>';
    details.appendChild(priceRow);
  }
});
